//プレイリストの最大数は1000
const FETCH_MAX_LIMIT = 1000
export const getFetchPlaylistsUrl = (params: string) =>
  `/v2/playlists?limit=${FETCH_MAX_LIMIT}&${params}`

export const getVideoPreviewInfoFetchUrl = (videoId: number, params: string) =>
  `/v2/videos/${videoId}/preview?${params}`
